const UpdateSeatsStatus = {
  order: Infinity,
  run($$) {
    $$.updateSeatsStatus = (newSeatsData) => {
      const updateSeat = function (src, dst) {
        dst.status = src.status;
        dst.item_type_ids = src.item_type_ids;
        return dst.el.attr({
          "data-status": src.status,
          "data-ticket-type-id": src.item_type_ids,
        });
      };

      newSeatsData.seats.forEach((newSeat) => {
        const oldSeat = $$.getSeat(newSeat.row, newSeat.seat);
        updateSeat(newSeat, oldSeat);
      });
    };
  },
};

window.SectionUpdateSeatsStatus = UpdateSeatsStatus;

export default UpdateSeatsStatus;
